
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, from, map, of } from 'rxjs';
import { UserService } from '../app/secure/_services/user/user.service';
import { PermissionService } from '../app/secure/_services/permission/permission.service';
import { ScopeType } from '../app/secure/plant-management/_enums/scope-type-enum';

export const governanceGuard: CanActivateFn = (_route, state) => {
    const router = inject(Router);
    const userService = inject(UserService);
    const permissionService = inject(PermissionService);

    return from(userService.loadEmployeeInformation()).pipe(
        map((user) => {
            const isAuthenticated = !!user;
            const isCoordinator = user?.roles?.includes('BusManagement_Coordinators');
            const isGovernance = user?.roles?.includes('BusManagement_Governance');

            if (isAuthenticated && (isCoordinator || isGovernance)) {
                if (isGovernance)
                    return true;
                else if (isCoordinator) {
                    permissionService.getUserPermission(user?.email).subscribe(permissions => {
                        if (permissions?.scope == ScopeType.GLOBAL || permissions?.scope == ScopeType.REGIONAL) {
                            return true;
                        }
                        else {
                            router.navigate(['/secure/unauthorized'], { queryParams: { returnUrl: state.url } });
                            return false
                        }
                    });
                    router.navigate(['/secure/unauthorized'], { queryParams: { returnUrl: state.url } });
                    return false;
                }
                else {
                    router.navigate(['/secure/unauthorized'], { queryParams: { returnUrl: state.url } });
                    return false// Permitir acceso
                }
            } else {
                router.navigate(['/secure/unauthorized'], { queryParams: { returnUrl: state.url } });
                return false; // Redirigir a la página de acceso no autorizado
            }
        }),
        catchError((err) => {
            console.error('Error in CoordinatorGuard:', err);
            router.navigate(['/secure/unauthorized'], { queryParams: { returnUrl: state.url } });
            return of(false); // Redirigir en caso de error
        })
    );
};
